export const SET_SERIE = 'SET_SERIE';
export const SET_SERIES = 'SET_SERIES';
export const UPDATE_SERIES = 'UDPATE_SERIES';
export const ADD_SERIES = 'ADD_SERIES';
export const REMOVE_SERIES = 'REMOVE_SERIES';